<template>
      <div class="schedule-list-container">
      <v-data-table
          :headers="headers"
          :items="items"
          dense
          :hide-default-footer="true"
          :disable-pagination="true"
          no-data-text="No Shifts"
          :show-expand="true"
          :item-class="row_classes"
          :fixed-header="true"
          class="filter-table"
          width="100%"
          height="480"
          :key="`schedule_list_${refresh}`"
          :search="shiftSearch"
      >

            <template v-slot:top>
              <v-text-field
                class="pa-0 ma-0 ml-n2 "
                flat
                dense
                solo
                hide-details
                v-model="shiftSearch"
                label="Filter"
                background-color="ycmd-very-lightest-gray"
              ></v-text-field>
            </template>

          <template v-slot:item.rounding="{item}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"
                >            
                  <v-icon>{{item.rounding ? 'check_box' : 'check_box_outline_blank'}}</v-icon>
                </div>
          </template>
          <template v-slot:item.catchall="{item}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"
                >            
                  <v-icon
                  >{{item.catchall ? 'check_box' : 'check_box_outline_blank'}}</v-icon>
                </div>
          </template>
          <template v-slot:item.outpatient="{item}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"
                >            
                  <v-icon>{{item.outpatient ? 'check_box' : 'check_box_outline_blank'}}</v-icon>
                </div>
          </template>
          <template v-slot:item.rotation="{item}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"
                >            
                  <v-icon>{{item.rotation ? 'check_box' : 'check_box_outline_blank'}}</v-icon>
                </div>
          </template>
          <template v-slot:item.assign_new_patient="{item}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"
                >            
                  <v-icon>{{item.assign_new_patient ? 'check_box' : 'check_box_outline_blank'}}</v-icon>
                </div>
          </template>
          <template v-slot:item.assign_temporary="{item}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"
                >            
                  <v-icon>{{item.assign_temporary ? 'check_box' : 'check_box_outline_blank'}}</v-icon>
                </div>
          </template>

            <template v-slot:item.name="{item, value}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"    
                >{{ value }}</div>
            </template>
            <template v-slot:item.filterName="{item, value}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"    
                >{{ value }}</div>
            </template>
            <template v-slot:item.startFormatted="{item, value}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"    
                >{{ value }}</div>
            </template>
            <template v-slot:item.endFormatted="{item, value}">
                <div
                    @click="rowClick(item)"
                    style="width: 100%;height: 100%;"
                >{{ value }}</div>
            </template>

            <template v-slot:expanded-item="{ headers, item }">
              <td
                  :colspan="headers.length"
                  classxxx="pa-0 ma-0 fs-10 pl-5 font-weight-light "    
              >
                  <div v-if="item.rules && item.rules.length"
                      v-html="rulesHtml(item.rules)"
                  />
                  <div
                    v-else
                  >No rules
                  </div>
              </td>
            
            </template>          

          
          <template v-slot:item.actionsxxx="{item}">

            <v-tooltip 
                        bottom
                        nudge-bottom="5"
                        color="ycmd-black"
                        content-class="fade-0">
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  color="ycmd-blue"
                  class="pointer"
                  :size="22"

                >
                  edit
                </v-icon>
              </template>
              <span>Edit</span>
            </v-tooltip>

          </template>                       

      </v-data-table>
      </div>

</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {formatSimple} from '@/methods/formatters';

import { parseJSON } from 'date-fns';
  export default {
    props: {
      shifts: {
          type: Array,
          default: () => []
      },
      filters: {
          type: Array,
          default: () => []
      },   
      refresh: {
        default: '',
        type: String
      },                     
              
    },
    components: {

    },    
    data: () => ({
      shiftSearch: null
    }),
    mounted() {
    },
    methods: {
      ...mapGetters('schedule',['getFacilityById']),

      rulesHtml (rules) {

          if (rules && rules.length) {
              let options = ''
              rules.map(r => {
                  options += `<li>${r}</li>`
              })
              let html = `<h5>Rules</h5><ul>${options}</ul>`
              return html
          }

          return null
      },   
      
      formatDate(dt) {

          let formatted = formatSimple(dt,'mm/dd/yyyyhh:mm a')
          
          return formatted
      },
      
      rowClick(item) {

        this.$emit('select', item)
      },
      translateShift(shift) {
        let s = JSON.parse(JSON.stringify(shift))
        s.startFormatted = this.formatTime(s.start)
        s.endFormatted = this.formatTime(s.end)
        if (s.filter) {
          let f = this.filterMap[s.filter]
          s.filterName = f ? f.name : s.filter

        }
        return s
      },
      twoDigit (num) {
        let str = num + ''
        if (str.length === 1) {
            str = '0' + str
        }
        return str
      },
      formatTime(time) {
        let pieces = time.split(':')
        let pm = false

        if (pieces[0] >= 12) {
          pieces[0] -= 12
          pm = true
        }
        return `${this.twoDigit(pieces[0])}:${this.twoDigit(pieces[1])}:${this.twoDigit(pieces[2])} ${pm ? 'PM': 'AM'}`
      },
      row_classes(item) {
        let classes = ['pa-0', 'ma-0', 'pointer']

        if (item.odd) {
          classes.push('odd')
        }

        return classes
      },      
    },
    computed: {
      filterMap(){
        let map={}
        this.filters.map(f => {
          map[f.id] = f
        })

        return map
      },
      items () {
        let arr = []
        let i=0
        this.shifts.map(s => {
          if (!s.personal) {
            let translated = this.translateShift(s)
            translated.odd = i++ % 2
            
            arr.push(translated)
          }
        })

        let sorted = arr.sort( (a,b) => {
            return a.name.localeCompare(b.name)
        })

        return sorted
      },
      headers () {
        let headers = [    
            {
                text: 'Name',
                value: 'name',
                width: '60%',
                sortable: true,
                cellClass:"pa-0 ma-0 pt-1",
                
            },
            {
                text: 'Filter',
                value: 'filterName',
                width: '40%',
                sortable: true,
                cellClass:"pa-0 ma-0 pt-1",
            },
            {
                text: 'Starts',
                value: 'startFormatted',
                width: '120px',
                sortable: true,
                cellClass:"pa-0 ma-0 pt-1",
            },
            {
                text: 'Ends',
                value: 'endFormatted',
                width: '120px',
                sortable: true,
                cellClass:"pa-0 ma-0 pt-1",
            },
            {
                text: 'Rounding',
                value: 'rounding',
                width: '80px',
                sortable: false,
                cellClass:"pa-0 ma-0 pt-1",
                align: 'center',
            },
            {
                text: 'Catch-all',
                value: 'catchall',
                width: '90px',
                sortable: false,
                cellClass:"pa-0 ma-0 pt-1",
                align: 'center',
            },  
            {
                text: 'Outpatient',
                value: 'outpatient',
                width: '80px',
                sortable: false,
                cellClass:"pa-0 ma-0 pt-1",
                align: 'center',
            },          
            {
                text: 'Rotating',
                value: 'rotation',
                width: '80px',
                sortable: false,
                cellClass:"pa-0 ma-0 pt-1",
                align: 'center',
            }, 
            {
                text: 'Assign New',
                value: 'assign_new_patient',
                width: '80px',
                sortable: false,
                cellClass:"pa-0 ma-0 pt-1",
                align: 'center',
            },    
            {
                text: 'Assign Temp',
                value: 'assign_temporary',
                width: '80px',
                sortable: false,
                cellClass:"pa-0 ma-0 pt-1",
                align: 'center',
            },  
            { text: '', 
                value: 'data-table-expand',
                cellClassxxx:"fs-12 filterTableExpand"
            },                                                                                  
        ]

        return headers
      },  
      actionList () {
        return []
      },

    },
    watch: {

    }
  }
</script>

